module.exports = __webpack_public_path__ + "static/media/abcnews.go.com_US_powerball-lottery-drawing-record-15b-jackpot-tonight__plot.319b82c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/abcnews.go.com_US_powerball-lottery-drawing-record-15b-jackpot-tonight__plot.png
// module id = 340
// module chunks = 0